import Vue from 'vue'
import App from './App.vue'

import store from './store'
//import store from './store';

Vue.config.productionTip = false

//Bootstrapを使用するために追加(2020.10.16)
//Bootstrapを使用するために追加(2020.10.16)
import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// <!-- Vue Router を使う為に記述 -->
// <!-- Vue Router を使う為に記述 -->
import router from './router'

new Vue({
  store:store,
  // <!-- Vue Router を使う為に記述 -->
  // <!-- Vue Router を使う為に記述 -->
  router,
  render: h => h(App),
}).$mount('#app')
